import React from "react";
import "./styles.scss";
import growthData from "../../../assets/data/growth";

const GrowthSection: React.FC = () => {
  return (
    <section className="growth-section" id="croissance">
      <h2>Natelco, votre accelerateur de croissance !</h2>
      <div className="growth-section-container">
        {growthData.map((value, index) => (
          <div key={index} className="growth-item">
            <h4 className="growth-item-title">{value.title}</h4>
            <ul className="growth-item-list">
              {value.items.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default GrowthSection;
